import { computePosition, offset, shift, arrow } from '@floating-ui/dom';

const createTooltip = async (element, text) => {
  const tooltip = document.createElement('div');
  tooltip.classList.add('gl-tooltip');
  tooltip.setAttribute('role', 'tooltip');
  tooltip.textContent = text;
  const arrowElement = document.createElement('div');
  arrowElement.classList.add('arrow');
  tooltip.appendChild(arrowElement);
  const updateTooltipPosition = async () => {
    const {
      x,
      y,
      placement,
      middlewareData
    } = await computePosition(element, tooltip, {
      placement: 'top',
      middleware: [offset(10), shift(), arrow({
        element: arrowElement
      })]
    });
    Object.assign(tooltip.style, {
      left: `${x}px`,
      top: `${y}px`
    });

    // style arrow element to position correctly
    const {
      x: arrowX,
      y: arrowY
    } = middlewareData.arrow;
    const staticSide = {
      top: 'bottom',
      right: 'left',
      bottom: 'top',
      left: 'right'
    }[placement.split('-')[0]];
    Object.assign(arrowElement.style, {
      left: arrowX != null ? `${arrowX}px` : '',
      top: arrowY != null ? `${arrowY}px` : '',
      right: '',
      bottom: '',
      [staticSide]: '-4px'
    });
  };
  const showTooltip = () => {
    tooltip.style.display = 'block';
    updateTooltipPosition();
  };
  const hideTooltip = () => {
    tooltip.style.display = '';
  };
  [['mouseenter', showTooltip], ['mouseleave', hideTooltip], ['focus', showTooltip], ['blur', hideTooltip]].forEach(_ref => {
    let [event, listener] = _ref;
    element.addEventListener(event, listener);
  });
  return tooltip;
};

export { createTooltip };
